import styled from "styled-components";

const TitleDiv = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.2%;
  font-size: 20px;
  font-weight: 300px;
  color: #3c4554;
  @media screen and (max-width: 480px) {
    font-size: 10px;
  }

`;

export default TitleDiv;
